import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBox20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconBox20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.882 18.441a2.5 2.5 0 0 0 2.236 0l6.776-3.388A2 2 0 0 0 19 13.263V7.046a2.5 2.5 0 0 0-1.382-2.236l-6.724-3.362a2 2 0 0 0-1.788 0L2.382 4.81A2.5 2.5 0 0 0 1 7.045v6.219a2 2 0 0 0 1.106 1.789zm-5.83-4.592a1 1 0 0 1-.552-.894V7.493a.25.25 0 0 1 .362-.224l5.835 2.918a1 1 0 0 1 .553.895v5.461a.25.25 0 0 1-.362.224zm.91-8.153a.25.25 0 0 0 0 .447l5.59 2.795a1 1 0 0 0 .895 0l5.59-2.795a.25.25 0 0 0 0-.447L10.447 2.9a1 1 0 0 0-.894 0zm13.176 1.573a.25.25 0 0 1 .362.224v5.462a1 1 0 0 1-.553.894l-5.835 2.918a.25.25 0 0 1-.362-.224v-5.461a1 1 0 0 1 .553-.895z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBox20);
